import React, { useState } from "react";
import validator from "validator";
import AddressForm from "./AddressForm"; // form aggiungi indirizzo
import OkPopup from "../OkPopup";

/*
curl --location --request POST 'https://ws.mediatoys.it/cliente/leggi_indirizzi_spedizione' \
--header 'Content-Type: application/json' \
--header 'Authorization: Bearer {{token}}' \
--header 'Accept: application/json' \
--data-urlencode 'id_e_user=2'
*/

const ProfileIndirizzi = (props) => {
  const [AddressList, setAddressList] = useState(null);
  const [AddAddress, setAddAddress] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [netError, setNetError] = useState(null);
  const [showDialog, setShowDialog] = useState(false);

  if (AddressList === null && !IsLoading) {
    getUserAddressList();
  }

  function getUserAddressList() {
    let params = [
      {
        name: "id_e_user",
        value: props.userData ? props.userData.id_e_user.toString() : "0",
      },
    ];
    props.wsCall(
      "https://ws.mediatoys.it/cliente/leggi_indirizzi_spedizione",
      IsLoading,
      setIsLoading,
      netError,
      () => {
        setAddressList("vuoto");
      },
      params,
      (respData) => {
        setAddressList(respData);
        //console.log(respData);
      }
    );
  }

  function removeAddress(addressId) {
    let params = [
      { name: "id_e_user", value: props.userData.id_e_user },
      { name: "id_e_utente", value: props.userData.id_e_user },
      { name: "id_tipo", value: "1" }, // 1-spedizione, 2-fatturazione
      { name: "id_e_indirizzo", value: addressId },
    ];
    props.wsCall(
      "https://ws.mediatoys.it/cliente/del_indirizzo_cliente",
      IsLoading,
      setIsLoading,
      netError,
      setNetError,
      params,
      (respData) => {
        //console.log(respData);
        setAddressList(respData.user.indirizzi_spedizione);
      }
    );
  }

  function impostaPredefinitoHandler(addressId) {
    let params = [
      { name: "id_e_user", value: props.userData.id_e_user },
      { name: "id_tipo", value: "1" }, // 1-spedizione, 2-fatturazione
      { name: "id_e_indirizzo", value: addressId },
    ];
    props.wsCall(
      "https://ws.mediatoys.it/cliente/set_indirizzo_preferito",
      IsLoading,
      setIsLoading,
      netError,
      setNetError,
      params,
      (respData) => {
        //console.log(respData);
        setAddressList(respData.user.indirizzi_spedizione);
      }
    );
  }

  function addAddressHandler(newAddress) {
    props.wsCall(
      "https://ws.mediatoys.it/cliente/add_indirizzo_spedizione",
      IsLoading,
      setIsLoading,
      netError,
      setNetError,
      newAddress,
      (respData) => {
        //console.log(respData);
        setAddressList(respData.user.indirizzi_spedizione);
        setAddAddress(false);
        setShowDialog(true);
      }
    );
  }

  const closeAddedDialog = () => {
    setShowDialog(false);
  };

  return (
    <div className="indirizzi_utente">
      {showDialog ? (
        <OkPopup
          titletext="Operazione completata"
          text="Indirizzo di spedizione aggiunto correttamente"
          closeHandler={closeAddedDialog}
        />
      ) : null}
      {IsLoading ? (
        <div className="spinner">
          <img src="/images/waiting.gif" alt="loading..." />
        </div>
      ) : !AddAddress ? (
        <div>
          <input
            className="aggiungi_indirizzo"
            type="button"
            value="Aggiungi indirizzo"
            onClick={() => setAddAddress(true)}
          />
          {AddressList !== null && AddressList !== "vuoto"
            ? AddressList.map((el) => (
                <div
                  className="riga_indirizzo_profilo"
                  key={"ad_" + el.id_e_user_spedizione}
                >
                  <p>
                    {el.nome + " " + el.cognome + ", " + el.indirizzo}
                    {el.presso.length > 0 ? " presso " + el.presso : null}
                    {", " + el.cap + " " + el.citta + " (" + el.provincia + ")"}
                    {", tel. " + el.telefono}
                  </p>

                  <div className="bottoni_utente">
                    {el.preferito !== "1" ? (
                      <input
                        type="button"
                        value="Imposta come preferito"
                        onClick={() =>
                          impostaPredefinitoHandler(el.id_e_user_spedizione)
                        }
                        className={
                          el.preferito === "1"
                            ? "pref"
                            : "non_pref imposta_predefinito"
                        }
                      />
                    ) : (
                      <input
                        type="button"
                        className="indirizzo_predefinito"
                        value="Indirizzo preferito"
                        onClick={(e) => e.preventDefault()}
                      />
                    )}

                    <input
                      className="rimuovi_indirizzo"
                      type="button"
                      value="Rimuovi indirizzo"
                      onClick={() => removeAddress(el.id_e_user_spedizione)}
                    />
                    <div className="clear"></div>
                  </div>
                  <div className="clear"></div>
                </div>
              ))
            : null}
        </div>
      ) : (
        <AddressForm
          userData={props.userData}
          //cssClass="col-01_anagrafica_cart"
          cssClass="anagrafica_profilo"
          addAddressHandler={addAddressHandler}
          setAddressList={setAddressList}
          wsCall={props.wsCall}
          setAddAddress={setAddAddress}
          loading={IsLoading}
          setLoading={setIsLoading}
          error={netError}
          setError={setNetError}
          cfg={props.cfg}
        />
      )}
    </div>
  );
};

export default ProfileIndirizzi;
